import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimFractionalPart',
})
export class TrimFractionalPartPipe implements PipeTransform {
  public minFractionDigits = 2;
  transform(value: number | string, precision?: number, addDecimaltoInteger: boolean = false, delimiter: string = ',') {
    if (value) {
      if (typeof value === 'number') {
        value = value.toString();
      }
      if (addDecimaltoInteger) {
        value = value.indexOf(delimiter) === -1 ? `${value}${delimiter}00` : value;
      }
      if (value.indexOf(delimiter) !== -1) {
        const res = value.split(delimiter);

        if (res[1]) {
          if (precision) {
            res[1] = res[1].substring(0, precision);

            // Удаляем лишние нули в конце дробной части
            res[1] = res[1].replace(/0+$/, '');

            // Добавляем нули до минимального количества, если дробная часть стала пустой
            while (res[1].length < this.minFractionDigits) {
              res[1] += '0';
            }
          }
          return res.join(delimiter);
        }
      }
    }
    return value;
  }
}
